export const filterAndStringifyParamsOverrides = (
	paramsOverrides: Record<string, string | boolean | number | undefined>
) =>
	Object.entries(paramsOverrides).reduce(
		(acc, [key, value]) => {
			if (value !== undefined && value !== null) {
				acc[key] = typeof value === 'string' ? value : value.toString()
			}
			return acc
		},
		{} as Record<string, string>
	)
